import React, {Component, PropTypes} from 'react';
import {Link, browserHistory} from "react-router";
import ErrorSpan from "../../../component/errorSpan";

var moment = require('moment');

var clearFlag = false;
import {ellaUrl} from '../../../path.config'
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'COMPONENT/tip'
import userService from 'SERVICES/ella/userService'
import {resultTip,errorShow,language} from 'UTIL/common'
const roleList = [];
import ellaService from 'SERVICES/purifier/ella/ellaService'
import {getNowFormatDate} from 'CONFIG/function'
export default class AdministratorsEdit extends Component {
    constructor(props) {
        super(props);
        this.btnSubmit = this.btnSubmit.bind(this);
        this.state = {
            id: this.props.params.id,
            userBase: {},
            roleList: [],
            userType: [],
            selectRole: [],
            extendsValue: [],
            url: ellaUrl
        };
    }
    componentDidMount() {
        var scrollFunc=function(e){
            e=e || window.event;
            if(e.wheelDelta){//IE/Opera/Chrome
                $("#laydate_box").hide()
            }else if(e.detail){//Firefox
                $("#laydate_box").hide()
            }
        }
        /*注册事件*/
        if(document.addEventListener){
            document.addEventListener('DOMMouseScroll',scrollFunc,false);
        }
        window.onmousewheel=document.onmousewheel=scrollFunc;
        var id = this.state.id;
        ellaService.userToUpdate(id).then(data=>{
            console.log(data)
            if (data.data != null) {
                var userBase = data.data.userBase;
                var roleList = data.data.roleList;
                var selectRole = data.data.selectRole;
                var userType = data.data.userType;
                this.setState({
                    map: data.data,
                    userBase: data.data.userBase,
                    roleList: data.data.roleList,
                    dvcTypes: userBase.dvcTypes,
                    selectRole: selectRole,
                    userType: userType,
                })
                $("#loginName").val(userBase.loginName);
                $("#realName").val(userBase.realName);
                $("#telephone").val(userBase.telephone);
                $("#email").val(userBase.email);
                $("#address").val(userBase.address);
                $("#userTypeId").val(2);
            }
        })
    }
    btnSubmit(event) {
        event.preventDefault();
        var id = this.state.id;
        var remark = $("#remark").val();

        var loginName = $("#loginName").val().trim();
        var realName = $("#realName").val().trim();
        var telephone = $("#telephone").val().trim();
        var email = $("#email").val().trim();
        var address = $("#address").val().trim();
        var userTypeId = 2;
        var chk_value = [];
        $('input[id="roleType"]:checked').each(function () {
            chk_value.push($(this).val());
        });
        let data = {
            id: id,
            loginName: loginName,
            realName: realName,
            telephone: telephone,
            email: email,
            address: address,
            roles: chk_value.toString(),
            userTypeId: 2,
        };
        let userBody  = JSON.stringify(data);
        let errorMessage = '';
        let ids = ['loginName', 'realName', 'telephone', 'email', 'address'];
        for (let i in ids) {
            if (data[ids[i]] == '') {
                errorMessage = '信息未填写！';
                errorShow(ids[i], errorMessage);
            }
        }
        if (errorMessage == '') {
            userService.saveUser({userBody}).then(data =>{
                resultTip(data,"/ella/user/user/administratorsList");
            })
        }

    }
    render() {
        const _this = this;
        var selectrole = this.state.selectRole;
        const roleList = this.state.roleList.map(function (str, index) {
            var div = <div className="col-xs-3">
                <input className="input-hidden" id="roleType" value={str.id}
                                                       type="checkbox"></input>
                <span className="checkbox-body"></span>
                <span className="checkbox-text">{str.roleName}</span></div>;
            if (selectrole != null && selectrole.indexOf(str.id) != -1)
                div = <div className="col-xs-3"><input className="input-hidden" id="roleType" value={str.id}
                                                       type="checkbox" checked></input>
                    <span className="checkbox-body"></span>
                    <span className="checkbox-text">{str.roleName}</span></div>;

            return div;
        });

        const userType = this.state.userType.map(function (str, index) {
            return <option value={str.id}>{str.name}</option>
        })

        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['userManage']}
                        <small>{language()['managersEdit']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-plus-circle"></i>
                            <h3 className="box-title">{language()['managersEdit']}</h3>
                        </div>
                        <div className="box-body">
                            <Tip ids="" />
                            <form id="micaFrom" className="form-horizontal">
                                <FormInput name="loginName" id="loginName"/>
                                <FormInput name="realName" id="realName"/>
                                <FormInput name="telephone" id="telephone"/>
                                <FormInput name="email" id="email"/>
                                <FormInput name="address" id="address"/>
                                <div className="row form-group">
                                    <label  className="multi-label control-label col-xs-2">{language()['userType']}</label>
                                    <div className="col-xs-3">
                                        <select  className="form-control" id="userTypeId">
                                            <option value={2}>{language()['managers']}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">{language()['selectRole']}</label>
                                    <div className="col-xs-10" style={{marginBottom: "15px"}}>
                                        {roleList}
                                    </div>
                                </div>
                                
                            </form>
                        </div>
                        <div className="box-footer">
                            <div className="col-xs-2"></div>
                            <div className="col-xs-1 text-center">
                                <a className="btn btn-success" onClick={this.btnSubmit}>{language()['submit']}</a>
                            </div>
                            <div className="col-xs-1 text-center">
                                <Link to="/ella/user/user/administratorsList" className="btn btn-default btn-md">
                                    {language()['return']}
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/administratorsEdit.js